var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomepageHeroBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 618,
    viewBox: "0 0 1440 618",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M-132 254.5C48.1667 191.5 354.381 101.782 226.5 24.9999C-12.5 -118.5 239.5 686.5 63 593C-78.2 518.2 164.167 499.5 303 499.5M1153.5 97.9999C1172 55.3332 1230.2 -22.0001 1315 9.99992C1421 49.9999 1169 260 1282.5 323C1396 386 1512 287 1464 204C1416 121 1164 333.5 1249.5 477C1317.9 591.8 1473 617.167 1542 615.5",
    stroke: "#B38AFF",
    strokeWidth: 4,
    strokeDasharray: "10 10"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomepageHeroBg);
export default __webpack_public_path__ + "static/media/homepage-hero-bg.02cc4e271faca3f8037b6b4856d58268.svg";
export { ForwardRef as ReactComponent };